class ViewLaborCategoryModalController {
  constructor($scope, $uibModalInstance, $http, $rootScope, toastr) {
    "ngInject";

    this.name = 'ViewLaborCategoryModal';
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.toastr = toastr;

    // Get the labor category and contract URL from the modal instance
    $scope.laborCategory = angular.copy($uibModalInstance.laborCategory) || {};
    $scope.contractUrl = $uibModalInstance.contractUrl;
    $scope.companyDegrees = $uibModalInstance.companyDegrees || [];

    $scope.close = function () {
      $uibModalInstance.close($scope.laborCategory);
    };

    // Store references for use in scope functions
    const self = this;

    // Update methods for xeditable fields
    $scope.updateField = function(field, value) {
      const id = $scope.laborCategory.id;
      if (!id) {
        self.toastr.error('Cannot update: Labor Category ID is missing.', 'ERROR');
        return;
      }

      // Get the original value from the modal instance (the value when modal was opened)
      const originalValue = $uibModalInstance.laborCategory[field];
      
      // Compare values - handle different types appropriately
      let valuesEqual = false;
      if (originalValue === value) {
        valuesEqual = true;
      } else if (originalValue == null && value == null) {
        valuesEqual = true;
      } else if (Array.isArray(originalValue) && Array.isArray(value)) {
        // For arrays (like applicableDegrees), compare by JSON string
        valuesEqual = JSON.stringify(originalValue) === JSON.stringify(value);
      } else if (typeof originalValue === 'number' && typeof value === 'number') {
        // For numbers, compare directly
        valuesEqual = originalValue === value;
      } else if (typeof originalValue === 'boolean' && typeof value === 'boolean') {
        // For booleans, compare directly
        valuesEqual = originalValue === value;
      } else {
        // For strings, trim and compare
        const originalStr = (originalValue || '').toString().trim();
        const newStr = (value || '').toString().trim();
        valuesEqual = originalStr === newStr;
      }

      // Don't fire REST request if value didn't change
      if (valuesEqual) {
        return;
      }

      // Store current value for potential revert
      const currentValue = $scope.laborCategory[field];

      self.$http
        .patch(
          self.$rootScope.apiHost + '/api/' + $scope.contractUrl + '/laborcategories/' + id,
          { [field]: value },
          { withCredentials: true }
        )
        .then(() => {
          $scope.laborCategory[field] = value;
          // Update the original in modal instance for future comparisons
          $uibModalInstance.laborCategory[field] = value;
          self.toastr.success('Successfully updated Labor Category.', 'SUCCESS');
        })
        .catch((err) => {
          console.error('Could not update Labor Category:', err);
          self.toastr.error('Could not update Labor Category.', 'ERROR');
          // Revert the value on error
          $scope.laborCategory[field] = currentValue;
        });
    };

    // Handle degree management
    $scope.degreeToAdd = undefined;
    $scope.selectDegree = function($item, $model, $label) {
      $scope.degreeToAdd = $item;
    };

    $scope.addAcceptableDegreeToLcat = function() {
      if (!$scope.laborCategory.applicableDegrees) {
        $scope.laborCategory.applicableDegrees = [];
      }
      if ($scope.degreeToAdd) {
        $scope.laborCategory.applicableDegrees.push($scope.degreeToAdd);
        $scope.updateField('applicableDegrees', $scope.laborCategory.applicableDegrees);
        $scope.degreeToAdd = undefined;
      }
    };

    $scope.removeDegree = function(index) {
      if ($scope.laborCategory.applicableDegrees && $scope.laborCategory.applicableDegrees.length > index) {
        $scope.laborCategory.applicableDegrees.splice(index, 1);
        $scope.updateField('applicableDegrees', $scope.laborCategory.applicableDegrees);
      }
    };

    // Handle dragging for slider handles
    $scope.startHandleDrag = function(event, type, isMin) {
      event.preventDefault();
      event.stopPropagation();
      
      const fieldPrefix = type === 'WithDegree' ? '' : '';
      const minField = type === 'WithDegree' ? 'minimumYearsOfExperienceWithDegree' : 'minimumYearsOfExperienceWithoutDegree';
      const maxField = type === 'WithDegree' ? 'maximumYearsOfExperienceWithDegree' : 'maximumYearsOfExperienceWithoutDegree';
      
      const container = event.currentTarget.closest('[style*="position: relative"]');
      const rect = container.getBoundingClientRect();
      const sliderWidth = rect.width - 16; // Account for 8px padding on each side
      
      const handleMouseMove = function(e) {
        const clickX = e.clientX - rect.left - 8; // Account for padding
        const clickPercent = Math.max(0, Math.min(100, (clickX / sliderWidth) * 100));
        const newValue = Math.round((clickPercent / 100) * 50);
        
        if (isMin) {
          const maxValue = $scope.laborCategory[maxField] || 50;
          const clampedValue = Math.max(0, Math.min(50, Math.min(newValue, maxValue)));
          $scope.laborCategory[minField] = clampedValue;
          $scope.$apply();
        } else {
          const minValue = $scope.laborCategory[minField] || 0;
          const clampedValue = Math.max(0, Math.min(50, Math.max(newValue, minValue)));
          $scope.laborCategory[maxField] = clampedValue;
          $scope.$apply();
        }
      };
      
      const handleMouseUp = function(e) {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
        
        // Update field on mouseup
        if (isMin) {
          $scope.updateField(minField, $scope.laborCategory[minField]);
        } else {
          $scope.updateField(maxField, $scope.laborCategory[maxField]);
        }
      };
      
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    };
  }
}

export default ViewLaborCategoryModalController;




// WEBPACK FOOTER //
// ./client/common/modals/viewLaborCategoryModal/viewLaborCategoryModal.controller.js